// extracted by mini-css-extract-plugin
export var previewImage = "imageTitle-module--previewImage--dno8A";
export var blogPostTitle = "imageTitle-module--blogPostTitle--hx+oA";
export var imageTitleContainer = "imageTitle-module--imageTitleContainer--jUDmZ";